import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useMediaQuery } from "react-responsive";
import { useHistory, useLocation } from "react-router-dom";

import { GoBackButton } from "pages/buyers/components/goBackButton";
import { clientProjectsWipSelector } from "data/selectors/underwriters";
import { PageHeader } from "./components/pageHeader";
import { StyledContainer, StyledMainContainer } from "./styles";

import {
  StyledSubHeaderContent,
  StyledBox,
  PlaceholderText,
} from "./components/styles";
import { AllProjectsTable } from "./components/allProjectsTable";

import LeftComponent from "./components/leftComponent";
import RightComponent from "./components/rightComponent";
import { getLimitValues, getLimitValuesUnderwriter } from "api/work_in_progress";
import { getClientProjectsInfoForWip, getClientProjectsInfoForWipUnderwriter } from "data/actions/underwriters";
import { getFirstPpcObject } from "./components/commonfunction";
import { getSingleProject, getSingleUnderwriterProject, filterProjects } from "api/prequalify";
import { AddProjectPopup } from "components/addProjectPopup";
import { AddUnderwriterProjectPopup } from "components/addUnderwriterProjectPopup"
import { saveProject, saveUnderwriterProject } from "api/dashboard";

const WorkInProgress = () => {
  const isMobile = useMediaQuery({ maxWidth: 453 });
  const location = useLocation();
  const dispatch = useDispatch();
  const [estimatedCostOfRevenue, setEstimatedCostOfRevenue] = useState(0);

  const [totalcostIncurredToDate, setTotalCostIncurredToDate] = useState(0);
  const companyName = location.state?.company_name || "";
  const accountId = location.state?.account_id;
  const userId = location.state?.userId;
  const clientProjects = useSelector(clientProjectsWipSelector);
  let history = useHistory();
  const [data, setData] = useState([]);
  const [project, setProject] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [openUnderwriterProjectEditPopup, setOpenUnderwriterProjectEditPopup] = useState(false);
  const [limitValues, setLimitValues] = useState({});
  const user = JSON.parse(localStorage.getItem("User"));
  const isAgentUnderwriter = user?.is_agent_to_access_esub_and_idp || false;
  const institutionId = location.state?.institutionId;
  
  // WIP specific state for agent underwriters
  const [selectedProject, setSelectedProject] = useState({});
  const [projectId, setProjectId] = useState("");

  useEffect(() => {
    const isUnderwriterWip = location.pathname.includes("underwriter/client/wip");

    if (isUnderwriterWip) {
      if (isAgentUnderwriter) {
        filterProjects("underway", { account_id: institutionId, user_id: userId || "" })
        .then((data) => {
          setData(data);
        })
        .catch((err) => {});
      } else {
        dispatch(
          getClientProjectsInfoForWipUnderwriter({ account_id: accountId }, "underway")
        );
      }

      getLimitValuesUnderwriter(
        { account_id: accountId },
        (res) => {
          setLimitValues(res);
        },
        () => { }
      );
    } else {
      dispatch(
        getClientProjectsInfoForWip({ account_id: accountId }, "underway")
      );

      getLimitValues(
        { account_id: accountId },
        (res) => {
          setLimitValues(res);
        },
        () => { }
      );
    }
  }, []);



  useEffect(() => {
    if (!isAgentUnderwriter && clientProjects) {
      setData(clientProjects);
    }
  }, [clientProjects]);
  const handleGoBack = () => {
    history.push("/underwriter-dashboard");
  };

  useEffect(() => {
    // Skip financial calculations for agent underwriters since they have different data structure
    if (isAgentUnderwriter) {
      setTotalCostIncurredToDate(0);
      setEstimatedCostOfRevenue(0);
      return;
    }

    const totalEstimatedCostOfRevenue = data?.reduce((total, obj) => {
      // add  original value of the main object
      let costOfRevenue = 0;
      if (obj?.wip_data?.length > 0) {
        // Assuming the last item in wip_data contains the most recent estimate
        const latestWipData = obj?.wip_data[obj?.wip_data?.length - 1];
        costOfRevenue = parseFloat(latestWipData?.estimated_cost_of_revenue);
      } else {
        costOfRevenue =
          parseFloat(obj?.original_estimated_cost_of_revenue) || 0;
      }
      // To minimize floating-point precision issues, keep track of totals in a higher precision
      total += costOfRevenue;

      return total;
    }, 0);

    const total_cost_incurred_to_date = data?.reduce((total, item) => {
      const firstPPCDataObject = getFirstPpcObject(item);

      const costForItem =
        parseFloat(firstPPCDataObject?.ppc_data?.cost_incurred_to_date) || 0;

      return total + costForItem;
    }, 0);

    setTotalCostIncurredToDate(total_cost_incurred_to_date);
    setEstimatedCostOfRevenue(Math.round(totalEstimatedCostOfRevenue));
  }, [data, isAgentUnderwriter]);

  // WIP setup for agent underwriters
  useEffect(() => {
    if (isAgentUnderwriter && data?.length > 0) {
      // Set the first project as selected by default
      const firstProject = data[0];
      setSelectedProject(firstProject);
      setProjectId(firstProject?.id || "");
    }
  }, [data, isAgentUnderwriter]);

  const editProject = (id) => {
    const isUnderwriterWip = location.pathname.includes("underwriter/client/wip");
    if (isUnderwriterWip) {
      getSingleUnderwriterProject(id, onSuccessUnderwriterProjectEdit, () => { });
    } else {
      getSingleProject(id, onSuccessEdit, () => { });
    }
  };

  const onSuccessUnderwriterProjectEdit = (res) => {
    setProject(res);
    setOpenUnderwriterProjectEditPopup(true);
  };

  const onSuccessEdit = (res) => {
    setProject(res);
    setOpenPopup(true);
  };


  const addProject = (data) => {
    let newProps = { ...data };
    if (accountId) {
      newProps = { ...newProps, institution_id: accountId };
    }
    const isUnderwriterWip = location.pathname.includes("underwriter/client/wip");
    if (isUnderwriterWip) {
      saveUnderwriterProject(newProps, onSuccess, () => { });
    } else {
      saveProject(newProps, onSuccess, () => { });
    }    
  };


  const onSuccess = () => {
    const isUnderwriterWip = location.pathname.includes("underwriter/client/wip");

    if (isUnderwriterWip) {
      if (isAgentUnderwriter) {
        filterProjects("", { institution_id: accountId, user_id: userId || "" })
        .then((data) => {
          setData(data);
        })
        .catch((err) => {});
      } else {
        dispatch(
          getClientProjectsInfoForWipUnderwriter({ account_id: accountId }, "underway")
        );
      }
    } else {
      dispatch(
        getClientProjectsInfoForWip({ account_id: accountId }, "underway")
      );
    }
    setProject("");

  };

  // WIP component functions for agent underwriters
  const handleProjectSelection = (project) => {
    setSelectedProject(project);
    setProjectId(project?.id || "");
  };
  return (
    <>
      {isAgentUnderwriter ? (
        <StyledContainer isMobile={isMobile}>
          <GoBackButton />
          <PageHeader
            subTitle="Work in Progress Schedule"
            companyName={companyName}
            hasButton={false}
            companyId={accountId}
          />

          <div
            style={{
              height: "10px",
              width: "80%",
              marginTop: "0px",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <a
              href="/wip-template-upload.xlsx"
              download="wip-template-upload.xlsx"
              style={{
                textDecoration: "none",
                color: "#FF6D1D",
              }}
            >
              {"Download Template"}
            </a>
          </div>

          {/* Agent Underwriter WIP Summary */}
          <StyledMainContainer>
            <div style={{ 
              display: "flex", 
              flexDirection: "column", 
              padding: "20px",
              gap: "15px"
            }}>
              <div style={{
                padding: "20px",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                textAlign: "center"
              }}>
                <div style={{ color: "#1A051D", fontSize: "32px", fontWeight: "bold" }}>
                  {data?.length || 0}
                </div>
                <div style={{ color: "#888888", fontSize: "14px" }}>
                  Active Projects Under Review
                </div>
              </div>
              
              <div style={{
                padding: "20px",
                backgroundColor: "#fff",
                borderRadius: "8px",
                border: "1px solid #e0e0e0"
              }}>
                <div style={{ color: "#1A051D", fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}>
                  Project Status Summary
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                  <span>Underway Projects:</span>
                  <span style={{ fontWeight: "bold" }}>
                    {data?.filter(p => p.project_status === "Underway")?.length || 0}
                  </span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                  <span>Completed Projects:</span>
                  <span style={{ fontWeight: "bold" }}>
                    {data?.filter(p => p.project_status === "Completed")?.length || 0}
                  </span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Other Status:</span>
                  <span style={{ fontWeight: "bold" }}>
                    {data?.filter(p => p.project_status !== "Underway" && p.project_status !== "Completed")?.length || 0}
                  </span>
                </div>
              </div>
            </div>
          </StyledMainContainer>

          {/* Projects List for Agent Underwriters */}
          <div
            style={{
              height: "auto",
              width: "100%",
              marginTop: "30px",
            }}
          >
            <StyledSubHeaderContent>Projects Under Review</StyledSubHeaderContent>
            {!(data?.length > 0) && (
              <StyledBox boxHeight="80%" borderRadius="10px" margin="10px 0px">
                <PlaceholderText>
                  No projects available for review
                </PlaceholderText>
              </StyledBox>
            )}
            {data?.length > 0 && (
              <div style={{ padding: "20px" }}>
                {data.map((project) => (
                  <div 
                    key={project.id}
                    style={{
                      padding: "15px",
                      marginBottom: "15px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      border: "1px solid #e0e0e0",
                      cursor: "pointer",
                      transition: "box-shadow 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.boxShadow = "none";
                    }}
                    onClick={() => {
                      // Navigate to individual project WIP page
                      history.push("/underwriter/client/wip/project", {
                        projectData: project,
                        projectId: project.id,
                        companyId: accountId,
                        company_name: companyName
                      });
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        <div style={{ fontSize: "16px", fontWeight: "bold", color: "#1A051D" }}>
                          {project.project_name}
                        </div>
                        <div style={{ fontSize: "14px", color: "#6E6B7B", marginTop: "4px" }}>
                          {project.project_number}
                        </div>
                        <div style={{ fontSize: "12px", color: "#888888", marginTop: "4px" }}>
                          {project.project_location}
                        </div>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <div style={{
                          padding: "4px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          backgroundColor: project.project_status === "Underway" ? "#e8f5e8" : 
                                         project.project_status === "Completed" ? "#e8f4f8" : "#f5f5f5",
                          color: project.project_status === "Underway" ? "#28a745" : 
                                project.project_status === "Completed" ? "#17a2b8" : "#6c757d"
                        }}>
                          {project.project_status}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </StyledContainer>
      ) : (
        <StyledContainer isMobile={isMobile}>
          <GoBackButton />
          <PageHeader
            subTitle="Work in Progress Schedule"
            companyName={companyName}
            hasButton={true}
            companyId={accountId}
          />

          <div
            style={{
              height: "10px",
              width: "80%",
              marginTop: "0px",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <a
              href="/wip-template-upload.xlsx"
              download="wip-template-upload.xlsx"
              style={{
                textDecoration: "none",
                color: "#FF6D1D",
              }}
            >
              {"Download Template"}
            </a>
          </div>

          <StyledMainContainer>
            <LeftComponent
              data={limitValues}
              accountId={accountId}
              totalCostIncurredToDate={totalcostIncurredToDate}
              totalEstimatedCostOfRevenue={estimatedCostOfRevenue}
            />
            <RightComponent
              data={data}
              totalCostIncurredToDate={totalcostIncurredToDate}
              totalEstimatedCostOfRevenue={estimatedCostOfRevenue}
            />
          </StyledMainContainer>
          <div
            style={{
              height: "300px",
              width: "100%",
              marginTop: "30px",
            }}
          >
            <StyledSubHeaderContent>List of Projects</StyledSubHeaderContent>
            {!(data?.length > 0) && (
              <StyledBox boxHeight="80%" borderRadius="10px" margin="10px 0px">
                <PlaceholderText>
                  Underway Projects will appear here
                </PlaceholderText>
              </StyledBox>
            )}
            {data?.length > 0 && (
              <AllProjectsTable
                data={data}
                setData={setData}
                clientCompanyName={companyName}
                companyId={accountId}
                editProject={editProject}
              />
            )}
          </div>
          <AddProjectPopup
            setOpenPopup={setOpenPopup}
            openPopup={openPopup}
            data={project}
            setData={setProject}
            handleButtonFunc={addProject}
            isMobile={isMobile}
            institution_id={accountId}
          />

          <AddUnderwriterProjectPopup
            setOpenPopup={setOpenUnderwriterProjectEditPopup}
            openPopup={openUnderwriterProjectEditPopup}
            data={project}
            setData={setProject}
            handleButtonFunc={addProject}
            isMobile={isMobile}
            institution_id={accountId}
          />
        </StyledContainer>
      )}
    </>
  );
};

export default WorkInProgress;
